module.exports = __webpack_public_path__ + "static/media/alpha_12.5603e6bd.png";